import { type CollectionSummaryJSONObject, isSystemTag } from '@ikegps/core-api';
import { action, observable, makeObservable } from 'mobx';
import { Services } from '../../services';
import { AppStore } from '../../store';

export class CollectionMoveModalCtrl {
	collections: CollectionSummaryJSONObject[];

	@observable tagName: string | null = null;
	@observable moving: boolean = false;

	constructor(collections: CollectionSummaryJSONObject[]) {
		makeObservable(this);

		this.collections = collections;
	}

	async moveCollections(departmentId: string) {
		if (departmentId == null || this.moving) {
			return;
		}

		const collectionsByTag: { [tagId: string]: CollectionSummaryJSONObject[] } = {};
		for (const collection of this.collections) {
			const tagId = collection.tags.find((t) => !isSystemTag(t));
			if (collectionsByTag[tagId] != null) {
				collectionsByTag[tagId].push(collection);
			} else {
				collectionsByTag[tagId] = [collection];
			}
		}

		this.setMoving(true);
		for (const tagId of Object.keys(collectionsByTag)) {
			const collectionGroup = collectionsByTag[tagId];
			const tag = AppStore.Tag.get(tagId);
			await Services.Collection.move(collectionGroup, tag.name, departmentId);
		}
		this.setMoving(false);
	}

	@action private setMoving(moving: boolean) {
		this.moving = moving;
	}
}
